// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"3b20a231","787":"c104bf20"}[chunkId] + ".chunk.js";
};